'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = HowItWorks;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function HowItWorks(_ref) {
    var _ref$explanation = _ref.explanation,
        explanation = _ref$explanation === undefined ? [] : _ref$explanation,
        image = _ref.image;

    return _react2['default'].createElement(
        'div',
        { className: 'seo-cloud-integrations__how-it-works' },
        _react2['default'].createElement(
            'h2',
            null,
            'How it Works'
        ),
        _react2['default'].createElement(
            'div',
            { className: 'row' },
            _react2['default'].createElement(
                'div',
                { className: 'screenshot-explanation large-3 large-push-9 columns' },
                explanation.map(function (exp) {
                    return renderExplanation(exp);
                })
            ),
            _react2['default'].createElement(
                'div',
                { className: 'dropbox-screenshot large-9 large-pull-3 columns' },
                _react2['default'].createElement('img', { src: image })
            )
        )
    );
}

function renderExplanation(exp) {
    return _react2['default'].createElement(
        'p',
        { key: exp },
        exp
    );
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/common/how-it-works-section.jsx
 ** module id = 1249
 ** module chunks = 0
 **/